// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"186":"90746e06","258":"3a731322","551":"e81b02b6"}[chunkId] + ".chunk.js";
};